import {
  Truck,
  buildNewTruck,
  TruckParams,
  ApiTruck,
  FormTruck,
  TruckApiParams,
} from "@/models/Truck";
import store, { StoreActions } from "@/store";
import { JSConn } from "@/utilities/js-conn";
import api from "@/api";

const itemDetails = {
  pluralName: "trucks",
  singularName: "truck",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  const formParams = jsConn.formParams as FormTruck;

  return {
    id: jsConn.formParams.id,
    truck: {
      id: formParams.id,
      status: formParams.status,
      name: formParams.name,
      tare_weight: formParams.tareWeight,
    },
  };
};

const apiParamsToTruckParams = (p: ApiTruck): TruckParams => {
  return {
    ...p,
  };
};

async function needTrucks(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    const tmpTrucks = jsConn.response.map((item: ApiTruck) => {
      return new Truck(apiParamsToTruckParams(item));
    });
    return store.dispatch(StoreActions.loadTrucks, tmpTrucks);
  });
}

async function createTruck(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      const tmpTruck = new Truck(apiParamsToTruckParams(jsConn.response));

      return store.dispatch(StoreActions.loadTruck, tmpTruck);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function updateTruck(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .updateItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      const tmpTruck = new Truck(apiParamsToTruckParams(jsConn.response));

      return store.dispatch(StoreActions.loadTruck, tmpTruck);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function needTruck(jsConn: JSConn) {
  return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
    const tmpTruck = new Truck(apiParamsToTruckParams(jsConn.response));

    return store.dispatch(StoreActions.loadTruck, tmpTruck);
  });
}

async function deleteTruck(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      store.dispatch(StoreActions.loadTruck, buildNewTruck());
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const trucksController = {
  needTrucks,
  needTruck,
  createTruck,
  updateTruck,
  deleteTruck,
};
